export enum IntegrationType {
  evo = "evo",
  rti = "rti",
  teixeiraPinto = "teixeiraPinto",
  trevo = "trevo",
  sislav = "sislav"
}

export namespace IntegrationType {
  export const translateType = (type: IntegrationType): string => {
    switch (type) {
      case IntegrationType.evo:
        return "EVO";
      case IntegrationType.rti:
        return "RTI";
      case IntegrationType.teixeiraPinto:
        return "Teixeira Pinto";
      case IntegrationType.trevo:
        return "Top Banho (Rede Trevo)";
      case IntegrationType.sislav:
        return "Sislav (lavanderia)";
      default:
        return "";
    }
  };

  export const integrationChoices = Object.values(IntegrationType)
    .filter(x => typeof x === "string")
    .map((type) => ({
      id: type,
      name: IntegrationType.translateType(type as IntegrationType),
    }));
}